<template>
  <button type="button" class="flex center-xs middle-xs">
    <svg
      viewBox="0 0 24 24"
      style="
        display: inline-block;
        color: rgba(0, 0, 0, 0.870588);
        fill: currentcolor;
        height: 24px;
        width: 24px;
        transition: all 450ms ease 0ms;
        user-select: none;
      "
    >
      <path
        style="transform: translate3d(1px, 1px, 0)"
        d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
      />
    </svg>
  </button>
</template>

<script setup lang="ts"></script>
